import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../api/store";
import { PolicySpecialUnderwritingProvisionsState } from "./policy-special-underwriting-provisions.state";

export type policySpecialUnderwritingProvisionsTypes =
    | null
    | "enrollment"
    | "rollOverProvisions"
    | "terminationOfIndividual"
    | "generalDefinitions"
    | "faceAmountOfInsurance" // GCLIP principal
    | "premiumComputation" // GCLIP principal
    | "nonCoverageProvisions" // GCLIP principal
    | "claimsProcedure"
    | "specialProvisions";

export type policySpecialUnderwritingProvisionsField =
    | "enrollment"
    | "rollOverProvisions"
    | "terminationOfIndividual"
    | "generalDefinitions"
    | "faceAmountOfInsurance" // GCLIP principal
    | "premiumComputation" // GCLIP principal
    | "nonCoverageProvisions" // GCLIP principal
    | "claimsProcedure"
    | "specialProvisions";

const initialState: PolicySpecialUnderwritingProvisionsState = {
    policySpecialUnderwritingProvisionsType: null,
    enrollment: "",
    rollOverProvisions: "",
    terminationOfIndividual: "",
    generalDefinitions: "",
    faceAmountOfInsurance: "", // GCLIP principal
    premiumComputation: "", // GCLIP principal
    nonCoverageProvisions: "", // GCLIP principal
    claimsProcedure: "",
    specialProvisions: "", // GPA
};

const policySpecialUnderwritingProvisionsSlice = createSlice({
    name: "policySpecialUnderwritingProvisionsSlice",
    initialState,
    reducers: {
        setPolicySpecialUnderwritingProvisionsType: ( state, action: PayloadAction<policySpecialUnderwritingProvisionsTypes> ) => {
            state.policySpecialUnderwritingProvisionsType = action.payload;
        },
        onChangeSpecialUnderWritingProvisionsState: ( state, action: PayloadAction<{ field: policySpecialUnderwritingProvisionsField; value: string; }> ) => {
            const { field, value } = action.payload;
            state[field] = value;
        },
        resetSpecialUnderWritingProvisionsState: () => initialState,
    },
});

export const {
    setPolicySpecialUnderwritingProvisionsType,
    onChangeSpecialUnderWritingProvisionsState,
    resetSpecialUnderWritingProvisionsState,
} = policySpecialUnderwritingProvisionsSlice.actions;

export const selectPolicySpecialUnderwritingProvisionsType = ( state: RootState ) => state.policySpecialUnderwritingProvisionsSlice.policySpecialUnderwritingProvisionsType;
export const selectPolicyEnrollment = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.enrollment;
export const selectPolicyRollOverProvisions = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.rollOverProvisions;
export const selectPolicyTerminationOfIndividual = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.terminationOfIndividual;
export const selectPolicyGeneralDefinitions = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.generalDefinitions;
export const selectFaceAmountOfInsurance = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.faceAmountOfInsurance; // GCLIP principal
export const selectPremiumComputation = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.premiumComputation; // GCLIP principal
export const selectNonCoverageProvisions = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.nonCoverageProvisions; // GCLIP principal
export const selectPolicyClaimsProcedure = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.claimsProcedure;
export const selectPolicySpecialProvisions = (state: RootState) => state.policySpecialUnderwritingProvisionsSlice.specialProvisions;

export default policySpecialUnderwritingProvisionsSlice.reducer;